import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { forDesktop } from '@westwing/ui-kit/breakPoints';
import StateInterface from '../../../redux/types';
import { useOverlayOutsideClick } from '../../../hooks/dom/useOverlayOutsideClick';
import { getOverlayById } from 'Client/redux/header/overlays/selectors';
import { hideOverlay } from 'Client/redux/header/overlays/actions';

const StyledContentOverlay = styled.div<{ right: number; isFullWidth: boolean }>`
    display: none;
    right: ${({ right }) => right}px;
    ${({ isFullWidth }) => (isFullWidth ? 'width: 100%;' : '')}
    ${forDesktop`
        display: block;
        position: absolute;
    `}
`;

const StyledWrapper = styled.div`
    z-index: ${({ theme }) => theme.zIndexContentOverlay};
    position: relative;
    width: 100%;
`;
interface ContentOverlayProps {
    identifier: string;
    rightPosition?: number;
    isFullWidth?: boolean;
    propagateOutsideClicks?: boolean;
    className?: string;
}

const ContentOverlay: React.SFC<ContentOverlayProps> = ({
    identifier,
    children,
    rightPosition = 0,
    isFullWidth = false,
    propagateOutsideClicks = false,
    className,
}) => {
    const dispatch = useDispatch();
    const onOverlayClose = () => {
        dispatch(hideOverlay(identifier));
    };
    const ref = useOverlayOutsideClick(onOverlayClose, propagateOutsideClicks);

    const isActive = useSelector<StateInterface, boolean>(
        state => getOverlayById(state.header.overlays, identifier).isActive
    );
    return (
        <>
            {isActive ? (
                <StyledWrapper className={className}>
                    <StyledContentOverlay right={rightPosition} ref={ref} isFullWidth={isFullWidth}>
                        {children}
                    </StyledContentOverlay>
                </StyledWrapper>
            ) : (
                <></>
            )}
        </>
    );
};

export default ContentOverlay;
